export const ValidateForm = (inputValue , setError) => {
  let error = {};
  let isValid = true;
  const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@“]+(\.[^<>()[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!inputValue?.anrede || inputValue?.anrede?.trim() === "") {
    error.anrede = "Bitte überprüfe deine Eingabe";
    isValid = false;
  }
  if (!inputValue?.vorname || inputValue?.vorname?.trim() === "") {
    error.vorname = "Bitte überprüfe deine Eingabe";
    isValid = false;
  }
  if (!inputValue?.nachname || inputValue?.nachname?.trim() === "") {
    error.nachname = "Bitte überprüfe deine Eingabe";
    isValid = false;
  }
  if (!inputValue?.firma || inputValue?.firma?.trim() === "") {
    error.firma = "Bitte überprüfe deine Eingabe";
    isValid = false;
  }
  if (!inputValue?.adresse || inputValue?.adresse?.trim() === "") {
    error.adresse = "Bitte überprüfe deine Eingabe";
    isValid = false;
  }
  if (!inputValue?.postleitzahl || inputValue?.postleitzahl?.trim() === "") {
    error.postleitzahl = "Bitte überprüfe deine Eingabe";
    isValid = false;
  }
  if (!inputValue?.ort || inputValue?.ort?.trim() === "") {
    error.ort = "Bitte überprüfe deine Eingabe";
    isValid = false;
  }
  if (!inputValue?.kontakt || inputValue?.kontakt?.trim() === "") {
    error.kontakt = "Bitte überprüfe deine Eingabe";
    isValid = false;
  }

  if (!inputValue?.eMail || inputValue?.eMail?.trim() === "") {
    error.eMail = "Bitte überprüfe deine Eingabe";
    isValid = false;
  } else if (!EMAIL_REGEX.test(inputValue.eMail)) {
    isValid = false;
    error.eMail = "Bitte überprüfe deine Eingabe";
  }

  if (!inputValue?.importantInfo || inputValue?.importantInfo?.trim() === "") {
    error.importantInfo = "Bitte überprüfe deine Eingabe";
    isValid = false;
  }

  setError(error);

  return isValid;
};

export default ValidateForm;
